import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  CreateProductDtoV3,
  CreateProductResponseV3,
  ListProductParamsV3,
  ProductDetailV3,
  ProductListResponseV3,
  ProductSkuIdsListResponseV3,
  ProductWithSkusV3,
  ProductsWithSkusPageV3,
  UpdateProductDtoV3,
  buildV3ProductParams,
} from '../../../../models/product-v3';

@Injectable({
  providedIn: 'root',
})
export class ProductV3Service {
  private readonly baseUrl = `${environment.url}/management/product/v3`;

  constructor(private readonly _http: HttpClient) {}

  /* =======================
   * LIST
   ======================= */
   list(
    storeId: string,
    params: ListProductParamsV3
  ): Observable<ProductListResponseV3> {
  
    const httpParams = buildV3ProductParams({
      ...params,
      _t: Date.now() // cache buster (solo pruebas)
    } as any);
  
    return this._http.get<ProductListResponseV3>(
      `${this.baseUrl}/store/${storeId}`,
      { params: httpParams }
    );
  }
  
  

  /* =======================
   * GET BY ID
   ======================= */
  get(
    storeId: string,
    productId: string
  ): Observable<ProductDetailV3> {
    return this._http.get<ProductDetailV3>(
      `${this.baseUrl}/store/${storeId}/${productId}`
    );
  }

  /* =======================
   * CREATE
   ======================= */
  create(
    body: CreateProductDtoV3,
    storeId: string
  ): Observable<CreateProductResponseV3> {
    return this._http.post<CreateProductResponseV3>(
      `${this.baseUrl}/store/${storeId}/products`,
      body
    );
  }

  /* =======================
   * UPDATE (PATCH)
   ======================= */
  update(
    storeId: string,
    productId: string,
    body: UpdateProductDtoV3
  ): Observable<void> {
    return this._http.patch<void>(
      `${this.baseUrl}/store/${storeId}/${productId}`,
      body
    );
  }

  /* =======================
   * DELETE
   ======================= */
  delete(storeId: string, productId: string): Observable<void> {
    return this._http.delete<void>(
      `${this.baseUrl}/store/${storeId}/${productId}`
    );
  }

  /* =======================
   * ENABLE / DISABLE
   ======================= */
  enable(storeId: string, productId: string): Observable<void> {
    return this._http.post<void>(
      `${this.baseUrl}/store/${storeId}/${productId}/enable`,
      {}
    );
  }

  disable(storeId: string, productId: string): Observable<void> {
    return this._http.post<void>(
      `${this.baseUrl}/store/${storeId}/${productId}/disable`,
      {}
    );
  }

  /* =======================
   * PRODUCT IDS + SKU IDS
   ======================= */
  getProductIdsWithSkuIds(
    storeId: string,
    params?: any
  ): Observable<ProductSkuIdsListResponseV3> {
    return this._http.get<ProductSkuIdsListResponseV3>(
      `${this.baseUrl}/store/${storeId}/productids`,
      { params }
    );
  }

  /* =======================
   * PRODUCT WITH SKUS
   ======================= */
  getProductWithSkus(
    storeId: string,
    productId: string
  ): Observable<ProductWithSkusV3> {
    return this._http.get<ProductWithSkusV3>(
      `${this.baseUrl}/store/${storeId}/with-skus/${productId}`
    );
  }

  getProductsWithSkus(
    storeId: string,
    params: { productIds: string; page?: number; size?: number }
  ): Observable<ProductsWithSkusPageV3> {
    return this._http.get<ProductsWithSkusPageV3>(
      `${this.baseUrl}/store/${storeId}/with-skus`,
      { params }
    );
  }
}
